import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

export default function App() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // console.log("ScrollY:", window.scrollY);
      if (window.scrollY > 100) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* <div style={{ height: "000px", padding: "20px" }}>
        <h1>Scroll Down</h1>
      </div> */}

      {visible && (
        <Button
          onClick={scrollToTop}
          variant="light"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            backgroundColor: "#000000",
            color: "white",
            fontSize: "22px",
            fontWeight: "bold",
            border: "none",
            zIndex: 9999999,
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#000000")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#000000")
          }
        >
          ↑
        </Button>
      )}
    </>
  );
}
